import { useQuery } from "@tanstack/react-query";
import axiosClient from "@/utils/axios-client";
import useIdentity from "@/features/ui/hooks/use-identity";
import {
  AgencyInquiryFilterType,
  AgencyInquiryThreadsResponse,
} from "@/features/inquiries/types";

// 문의 등록·읽음 처리 뒤에 이 키 앞부분으로 무효화한다(메뉴 배지·문의함 목록 갱신)
export const AGENCY_INQUIRY_THREADS_QUERY_KEY = [
  "order-sheet-set",
  "agency-inquiry-threads",
];

export const AGENCY_INQUIRY_PAGE_SIZE = 20;

// 에이전시 문의함 목록. 에이전시가 아니면 부르지 않는다.
const useGetAgencyInquiryThreads = ({
  filterType = "ALL",
  pageNumber = 1,
  pageSize = AGENCY_INQUIRY_PAGE_SIZE,
}: {
  filterType?: AgencyInquiryFilterType;
  pageNumber?: number;
  pageSize?: number;
} = {}) => {
  const identity = useIdentity();
  const agencyId =
    identity?.company?.type === "AGENCY" ? identity.company.id : undefined;

  return useQuery({
    queryKey: [
      ...AGENCY_INQUIRY_THREADS_QUERY_KEY,
      agencyId,
      filterType,
      pageNumber,
      pageSize,
    ],
    queryFn: async () => {
      const { data } = await axiosClient.get<AgencyInquiryThreadsResponse>(
        `/agencies/${agencyId}/order-sheet-set-inquiries`,
        {
          params: {
            filter_type: filterType,
            page_number: pageNumber,
            page_size: pageSize,
          },
        }
      );
      return data;
    },
    enabled: Boolean(agencyId),
    refetchOnWindowFocus: "always",
  });
};

export default useGetAgencyInquiryThreads;
